import { LocaleLabels } from "@/enums/LocaleLabels";
import { defineStore } from "pinia";

export const useLocaleStore = defineStore('locale', {
    state: () => {
      return {
        Locale: LocaleLabels.English
      }
    },
    persist: {
      storage: localStorage,
    },
    getters: {
      getLocale(state) : LocaleLabels {
        return state.Locale;
      },
    },
    actions: {
      updateLocale(locale: LocaleLabels) {
        this.Locale = locale;
      },
    }
  })